<template>
  <div class="w100 pt20 pb20 pl20 pr20" v-loading="loading" v-if="userToken">
    <el-table class="w100 table" header-row-class-name="table-head" :row-class-name="hasRead" height="calc(90vh - 220px)" stripe :data="list" @row-click="clickRow">
      <el-table-column align="center" label="序号" width="50px">
        <template slot-scope="scope">
          {{ pageNum * pageSize - pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="taskTitle" label="标题"></el-table-column>
      <el-table-column align="center" prop="content" label="内容" v-if="hasContent"></el-table-column>
      <el-table-column align="center" label="申请时间" width="200">
        <template slot-scope="scope">
          {{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm') }}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" prop="actionName" label="操作状态" width="150"></el-table-column> -->
      <el-table-column align="center" prop="processState" label="申请状态" width="150"></el-table-column>
    </el-table>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    <IframeView ref="iframeView" :append-to-body="true" @init-page="initPage" @fetch-list="fetchList" />
  </div>
  <span class="w100 flex-box al-c ju-c tx-c grey" style="height: calc(100vh - 220px);" v-else>
    请先<router-link class="blue" to="/login">登录</router-link>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import IframeView from "@/components/public/IframeView";

export default {
  name: "ApprovalLaunch",
  components: {
    IframeView
  },
  props: ["process-def-id", "process-version-id"],
  data() {
    return {
      loading: false,

      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0,

      hasContent: false
    };
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  created() {
    if (this.userToken) {
      this.initPage();
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchList() {
      let obj = {};
      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;

      this.loading = true;
      this.$http
        .post(
          "/serveCenter/hasLaunchTask",
          this.$qs.stringify({
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            processDefVerId: this.processVersionId
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
            this.hasContent =
              this.list.length && this.list[0].content ? true : false;
          }

          this.$nextTick(() => {
            this.loading = false;
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    initPage() {
      this.pageNum = 1;
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    clickRow(item) {
      this.list[item.index].hasRead = true;
      this.$refs.iframeView.showView(item.taskUrl, item.taskInstId);
    },
    hasRead({ row, rowIndex }) {
      row.index = rowIndex;
      if (row.hasRead) {
        return "cu-p";
      }
      return "bold cu-p";
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
